module.exports = __webpack_public_path__ + "img/Screenshot 2566-07-26 at 15.06.40@2x.7167954a.png";